export default __webpack_public_path__ + "static/latest-1-c47ad245f23c87b99a76e07f79da5edc.webp";